import { VisibleField } from "@tenforce/product-fields"
import { VisibleFieldResult } from "../components/collection"
import { RequestErrorDataApi } from "../errors"
import { formatString } from "../util/Strings"
import { Exceptions } from "../util/Translations"
import { dataAPI } from "./api"
import { VisibleFieldResultDTO, VisibleFieldDTO } from "./models/dto/collection"

const {
    AnErrorOccurredWhileFetchingVisibleFieldsFor = 'An error occurred while fetching the visible fields for ["{0}"].',
} = Exceptions

const parseFieldData = (dtoData: VisibleFieldDTO): VisibleField => {
    return {
        id: dtoData.Id,
        label: dtoData.Label,
        isActive: dtoData.IsActive,
    }
}

export const getVisibleFieldsList = async (
    itemId: number,
    fieldId: string,
    odataType: string,
): Promise<VisibleFieldResult> => {
    return dataAPI
        .getJSON<VisibleFieldResultDTO>(
            `ItemFields/ItemId=${itemId},FieldDefinitionId='${fieldId}'/${odataType}/Query`,
        )
        .then((response) => {
            return {
                filter: response.Filter,
                sorting: response.Sorting,
                fields: response.Fields.map(parseFieldData),
            }
        })
        .catch(async (error) => {
            if (error instanceof Response) {
                const errorMessage = formatString(
                    AnErrorOccurredWhileFetchingVisibleFieldsFor,
                    fieldId,
                )
                throw await RequestErrorDataApi.create(
                    errorMessage,
                    error.status,
                    error,
                )
            }
            throw error
        })
}
